import { Link } from "@tanstack/react-router";
import { SectionHeading } from "@/components/ui-ext/SectionHeading";
import { PortfolioCard } from "@/components/portfolio/PortfolioCard";
import { PORTFOLIO } from "@/content/portfolio";
import { siteConfig } from "@/config/site";


export function HomePortfolioSpotlight() {
  const featured = PORTFOLIO.filter((p) => p.featured).slice(0, 4);
  return (
    <section className="container-page py-24 md:py-32">
      <div className="flex items-end justify-between gap-6 flex-wrap">
        <SectionHeading
          eyebrow="Portfolio"
          title="Growth engines we've engineered"
          intro={`Recent programmes for operators in ${siteConfig.contact.address.city} and across North America. Real Semrush and Search Console data — captured, dated, and sourced.`}
        />

        <Link
          to="/portfolio/"
          className="text-sm text-primary hover:underline whitespace-nowrap"
        >
          See all work →
        </Link>
      </div>
      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {featured.map((p) => (
          <PortfolioCard key={p.slug} project={p} />
        ))}
      </div>
    </section>
  );
}
